// Used on backButton.subscribeWithPriority to override default back button action
// Priority to override is link to Handler context
// See https://ionicframework.com/docs/developing/hardware-back-button#internal-framework-handlers
export const OVERLAYS_PRIORITY: number = 110;
